import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress,
  Paper
} from '@mui/material';
import { AssignmentTurnedIn, TrendingUp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ProfileCompletionPrompt = ({ open, missingFields, onClose }) => {
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '32px',
          boxShadow: '0 24px 64px rgba(0, 0, 0, 0.2)',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: 'none',
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        {/* Icon */}
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            border: '4px solid rgba(255, 255, 255, 0.3)',
          }}
        >
          <AssignmentTurnedIn sx={{ fontSize: 56, color: '#fff' }} />
        </Box>

        {/* Title */}
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700, 
            color: '#fff',
            mb: 2,
            textShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
          }}
        >
          Завершите профилирование
        </Typography>

        {/* Description */}
        <Typography 
          variant="h6" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.95)',
            mb: 3,
            lineHeight: 1.6,
            fontWeight: 400
          }}
        >
          Пройдите <strong style={{ fontWeight: 700 }}>5 профильных опросов</strong>,<br />
          чтобы получить доступ к платным опросам
        </Typography>

        {/* Benefits Card */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '24px',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            mb: 3
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <TrendingUp sx={{ color: '#744210', fontSize: 28 }} />
            </Box>
            <Box sx={{ textAlign: 'left', flex: 1 }}>
              <Typography variant="body1" sx={{ fontWeight: 600, color: '#2d3748', mb: 0.5 }}>
                Бонус за профилирование
              </Typography>
              <Typography variant="body2" sx={{ color: '#2d3748' }}>
                <strong style={{ color: '#d35400', fontWeight: 700, fontSize: '1.05rem' }}>+0.3 балла</strong> за каждый пройденный профильный опрос
              </Typography>
            </Box>
          </Box>

          <LinearProgress
            variant="determinate"
            value={0}
            sx={{
              height: 8,
              borderRadius: 4,
              bgcolor: '#e2e8f0',
              '& .MuiLinearProgress-bar': {
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: 4,
              }
            }}
          />
          <Typography variant="caption" sx={{ color: '#a0aec0', mt: 1, display: 'block' }}>
            0 из 5 профильных опросов завершено
          </Typography>
        </Paper>

        {/* Info Note */}
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.85)',
            lineHeight: 1.6
          }}
        >
          💡 Профильные опросы помогают нам подобрать для вас<br />
          наиболее релевантные и высокооплачиваемые задания
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'center' }}>
        <Button
          onClick={handleGoToProfile}
          variant="contained"
          size="large"
          fullWidth
          sx={{
            background: '#fff',
            color: '#667eea',
            borderRadius: '20px',
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '1.1rem',
            py: 1.5,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
            '&:hover': {
              background: '#f7fafc',
              boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s ease'
          }}
        >
          Перейти к профильным опросам
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileCompletionPrompt;
